import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { GlassCard, Field } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import api from "@/lib/api";

export const STRATEJI = [
  { value: "az_gecikme", label: "En az gün kaydırarak (açık gününe en yakın vadeli fatura önce)" },
  { value: "tutar_buyuk", label: "Tutarı büyük olandan başla (açığı en az faturayla kapat)" },
  { value: "vade_yakin", label: "Vadesi en yakın olandan başla (en erken ödenecek önce)" },
];
const VARSAYILAN = { strateji: "az_gecikme", max_gun: 15, haric_tedarikciler: [] };

export const ErtelemeAyar = ({ value, onChange }) => {
  const e = { ...VARSAYILAN, ...(value || {}) };
  const [ted, setTed] = useState([]);
  useEffect(() => {
    api.get("/cariler").then((r) => setTed(r.data.filter((c) => c.tip !== "musteri" && c.aktif !== false)));
  }, []);
  const set = (k, v) => onChange({ ...e, [k]: v });
  const toggle = (id, on) => set("haric_tedarikciler", on ? [...e.haric_tedarikciler, id] : e.haric_tedarikciler.filter((x) => x !== id));
  return (
    <GlassCard className="p-6 space-y-5" data-testid="erteleme-ayar">
      <p className="text-xs text-muted-foreground">Nakit Akışı ekranında nakit açığı (sıfırın veya minimum nakit bakiyenin altı) olan günler için hangi tedarikçi ödemelerinin kaydırılabileceği bu kurallara göre önerilir. Öneriler hiçbir kaydı değiştirmez.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Hangi ödemeler önce ertelenmeye önerilsin?"><SelectBox testid="erteleme-strateji" value={e.strateji} onChange={(v) => set("strateji", v)} options={STRATEJI} /></Field>
        <Field label="Bir ödeme en fazla kaç gün kaydırılabilir? (1–90)">
          <Input data-testid="erteleme-max-gun" type="number" min="1" max="90" className="bg-white/5" value={e.max_gun} onChange={(ev) => set("max_gun", Number(ev.target.value))} />
        </Field>
      </div>
      <div>
        <div className="text-xs text-muted-foreground mb-2">Ertelenmeyecek (kritik) tedarikçiler — işaretlenenler hiç önerilmez</div>
        {ted.length === 0 ? <div className="text-xs text-muted-foreground" data-testid="erteleme-ted-bos">Tedarikçi kaydı yok.</div> : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-2 max-h-64 overflow-y-auto erp-scroll">{ted.map((c) => (
            <label key={c.id} className="flex items-center gap-2 text-sm rounded-lg bg-white/[0.04] px-3 py-2 cursor-pointer">
              <Checkbox data-testid={`erteleme-haric-${c.id}`} checked={e.haric_tedarikciler.includes(c.id)} onCheckedChange={(v) => toggle(c.id, !!v)} />
              <span className="truncate">{c.unvan}</span>
            </label>
          ))}</div>
        )}
      </div>
    </GlassCard>
  );
};
